// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1mRIV","logo":"Header_logo__3uuSv","loginBlock":"Header_loginBlock__27Z9w"};